import { makeStyles } from '@fluentui/react';
export const useStyles = makeStyles((theme) => ({
  categoryType: {
    color: theme.palette.themePrimary,
  },
  typeContainer: { alignItems: 'center', margin: '10px 20px', width: 150 },

  callout: {
    backgroundColor: theme.palette.neutralLighterAlt,
  },
  onRenderColumnStack: {
    height: 25,
  },
  groupItemHeight: {
    height: 30,
    padding: 10,
  },
  workgroupGroup: {
    backgroundColor: theme.palette.themePrimary,
    borderRadius: 5,
  },
  
  fontColor: {
    color: 'white',
  },
}));
